// 路由映射表
import { Navigate, Outlet } from "react-router-dom";
import Login from "../pages/Login";
import Teamanagement from "../pages/TeamManagement/index";
import Layout from "../layouts/BasicLayout";
import CreationScript from "../pages/CreationScript/index";
import CreateVideoanalysis from "../pages/CreateVideo";
import CreateVideodetil from "../pages/CreateVideo/detil/index";
import Invitation from "../pages/Invitation";
import CreateIntercept from "./createIntercept";
import { lazy } from "react";
import MixCutDetail from "@/pages/VideoClips/MixCutDetail/MixCutDetail";
import QuickCut from '@/pages/VideoClips/QuickCut/index'
import TeamOverview from "@/pages/TeamOverview";
import VideoEditing from "@/pages/VideoEditing";
import { getTokenToLocalStorage } from "@/utils/token";
import ProtectedRoute from "./ProtectedRoute";
import RedirectRoute from "./RedirectRoute";
import VoiceList from "@/pages/CreationSpace/VoiceClone/VoiceList/VoiceList";
import HotListOverview from "@/pages/HotListOverview";
import IndustrySubscribe from "@/pages/IndustrySubscribe";
import CreativeInspiration from "@/pages/CreativeInspiration";
import Clip from "@/pages/Clip";
// const TextEditor = lazy(() => import("../pages/TestModule/TestEditor/Index"));
// 使用路由懒加载（lazy）
// const Home = lazy(() => import("../pages/home"));

const CreativeScript = lazy(() => import("@/pages/CreateScript/Index"));
const UserCenter = lazy(() => import("@/pages/UserCenter"));
const TaskList = lazy(() => import("@/pages/TaskCenter"));
const Workbench = lazy(() => import("@/pages/Workbench"));
const MagicClip = lazy(() => import("@/pages/MagicClip"));
const CloudClip = lazy(() => import("@/pages/CloudClip"))

const RecyclingStation = lazy(
  () => import("../pages/CreationSpace/RecyclingStation/RecyclingStation")
);
const CreativeSpace = lazy(
  () => import("../pages/CreationSpace/CreativeSpace/index")
);

const VideoClips = lazy(
  () => import("../pages/VideoClips/IntelligenceMixCut/IntelligenceMixCut")
);

const AIThemeCreation = lazy(
  () => import("../pages/AICreation/AIThemeCreation")
);

const AIThemeCreationTable = lazy(
  () => import("../pages/AICreation/AIThemeCreationTable/AIThemeCreationTable")
);

const AIThemeScriptCreate = lazy(
  () => import("../pages/AICreation/AIThemeScriptCreate/AIThemeScriptCreate")
);

const VideoClipResult = lazy(
  () => import("../pages/VideoClips/VideoClipResult/VideoClipResult")
);
const VoiceDetail = lazy(
  () => import("@/pages/CreationSpace/VoiceClone/VoiceDetail/VoiceDetail")
);
const ImageText = lazy(
  () => import("../pages/ImageText/ImageText/ImageText") // 图文创作
);
const ImageTextResult = lazy(
  () => import("../pages/ImageText/ImageTextResult/index") // 图文创作结果
);
const Seo = lazy(() => import("../pages/Seo/Setting/index"));
const SeoRanking = lazy(() => import("../pages/Seo/KeywordsRanking/index"));
const SeoResult = lazy(() => import("../pages/Seo/SeoResult/index"));
const CreativeTool = lazy(
  () => import("../pages/CreativeTool/index") // 创作工具
);
const ImageProcess = lazy(
  () => import("../pages/CreativeTool/ImageProcess/index") // 图片处理
);
const ImageProcessAdd = lazy(
  () => import("../pages/CreativeTool/ImageProcess/add/index") // 图片处理任务新增
);
const Material = lazy(() => import("../pages/Material/index"));
const TemplatePage = lazy(() => import("../pages/Material/TemplatePage/index")); // 图片模板
const CoverPage = lazy(() => import("../pages/Material/CoverPage/index")); // 封面模板
const VideoTemplatePage = lazy(() => import("../pages/Material/VideoPage/index")); // 视频模板
const VideoPage = lazy(() => import("../pages/PublishManage/VideoPage/index")); // 视频页面
const ImagePage = lazy(() => import("../pages/PublishManage/ImagePage/index")); // 图文页面
const VideoDesignTemplate = lazy(() => import("../pages/Material/VideoDesignTemplate/index")); // 视频模板
const ImageDesignTemplate = lazy(() => import("../pages/Material/ImageDesignTemplate/index")); // 图文模板
const QuickCutResult = lazy(() => import("../pages/VideoClips/QuickCutResult/VideoClipResult"));
const DigitalHuman = lazy(() => import("../pages/DigitalHuman/index"));
const DigitalHumanDetail = lazy(() => import("../pages/DigitalHuman/DigitalDetail/DigitalDetail"))
const DigitalVideoTask = lazy(() => import("../pages/DigitalHuman/VideoTask/VideoTask"))
const DigitalAgreement = lazy(() => import("../pages/DigitalHuman/Agreement/Agreement"))
const DataDashboard = lazy(() => import("../pages/DataDashboard/IndexPage/index"));
const DigitalRecycleBin = lazy(() => import("../pages/DigitalHuman/RecycleBin/RecycleBin"))
const Dashboard = lazy(() => import("../pages/dashboard"));
const MusicManagement = lazy(
  () => import("../pages/MusicManagement")
);
/**
 * 路由映射表
 */
const routers = [
  {
    path: "/",
    element: <Navigate to="/work-bench" />,
  },
  {
    path: "/",
    element: (
      <RedirectRoute>
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      </RedirectRoute>
    ),
    children: [
      {
        path: "/work-bench",
        element: <Workbench />,
      },
      {
        path: "/creative-script",
        element: <CreativeScript />,
      },
      {
        path: "/ai-creation",
        element: <AIThemeCreation />,
      },
      {
        path: "/creative-space/recycling-station",
        element: <RecyclingStation />,
      },
      {
        path: "/creative-space",
        element: <CreativeSpace />,
      },
      {
        path: "/creative-tool",
        element: <CreativeTool />, // 创作工具
      },
      {
        path: "/creative-tool/imageProcess",
        element: <ImageProcess />, // 图片处理
      },
      {
        path: "/creative-tool/imageProcess/add",
        element: <ImageProcessAdd />, // 图片处理任务新增
      },
      {
        path: "/voice-list",
        element: <VoiceList />,
      },
      {
        path: "/voice-detail",
        element: <VoiceDetail />,
      },
      {
        path: "/video-clips",
        element: <VideoClips />,
      },
      {
        path: "/ai-creation",
        element: <AIThemeCreation />,
      },
      {
        path: "/aithemecreationtable",
        element: <AIThemeCreationTable />,
      },
      {
        path: "/aithemescriptcreate",
        element: <AIThemeScriptCreate />,
      },
      {
        path: "/creation-script/:id",
        element: (
          <CreateIntercept>
            <CreationScript />
          </CreateIntercept>
        ),
      },
      {
        path: "/creation-script",
        element: (
          <CreateIntercept>
            <CreationScript />
          </CreateIntercept>
        ),
      },
      {
        path: "/team-anagement",
        element: <Teamanagement />,
      },
      {
        path: "/team-overview",
        element: <TeamOverview />,
      },
      {
        path: "/analysis-video",
        element: <CreateVideoanalysis />,
      },

      {
        path: "/analysis-video/:id",
        element: <CreateVideodetil />,
      },
      {
        path: "/task-center",
        element: <TaskList />,
      },
      {
        path: "/user",
        element: <UserCenter />,
      },
      {
        path: "/hot",
        element: <HotListOverview />,
      },
      {
        path: "/industry-subscribe",
        element: <IndustrySubscribe />,
      },
      {
        path: "/creative-idea",
        element: <CreativeInspiration />,
      },
      {
        path: "/seo-setting",
        element: <Seo />,
      },
      {
        path: "/seo-result",
        element: <SeoResult />,
      },
      {
        path: "/seo-ranking",
        element: <SeoRanking />,
      },
      {
        path: "/material",
        element: <Material />,
      },
      {
        path: "/material/image/:id", // 图片模板
        element: <TemplatePage />,
      },
      {
        path: "/material/cover/:id", // 封面模板
        element: <CoverPage />,
      },
      {
        path: "/material/video/:id", // 视频模板
        element: <VideoTemplatePage />,
      },
      {
        path: "/material/video-add/:id/:editType",
        element: <VideoDesignTemplate />, // 视频模板-新增
      },
      {
        path: "/material/image-add/:id/:type/:editType",
        element: <ImageDesignTemplate />, // 图文模板-新增
      },
      {
        path: "/publish/video",
        element: <VideoPage />, // 视频管理
      },
      {
        path: "/publish/image",
        element: <ImagePage />, // 图文管理
      },
      {
        path: "/digital-human-list",
        element: <DigitalHuman />
      },
      {
        path: "/digital-detail",
        element: <DigitalHumanDetail />
      },
      {
        path: "/digital-video-task",
        element: <DigitalVideoTask />
      },
      {
        path: "/cloud-clip",
        element: <CloudClip />
      },
      {
        path: "/cloud-clip/detail",
        element: <CloudClip />,
      },
      {
        path: "/digital-recyclebin",
        element: <DigitalRecycleBin/>
      },
      {
        path: "/music-management",
        element: <MusicManagement />, // 音乐管理
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },

  {
    path: "/mix-detail/:id/:script_id?",
    element: <MixCutDetail />,
  },
  {
    path: "/quick-cut/:id",
    element: <QuickCut />, // 迅剪
  },
  {
    path: "/image-text",
    element: <ImageText />,
  },
  {
    path: "/image-text-result/:projectId/:count/:title/:aspect/:width/:height",
    element: <ImageTextResult />,
  },
  {
    path: "/video-clip-result/:projectId/:count",
    element: <VideoClipResult />,
  },
  {
    path: "/quick-cut-result/:projectId/:count",
    element: <QuickCutResult />,
  },
  {
    path: "/invite",
    element: <Invitation />,
  },
  {
    path: "/video-editing",
    element: <VideoEditing />,
  },
  {
    path: "/video-editing/:id",
    element: <VideoEditing />,
  },
  {
    path: '/data-dashboard',
    element: <Dashboard />
  },
  {
    path: "/clip",
    element: <Clip />,
  },
  {
    path: "/magicclip",
    // element: <Clip />,
    element: <MagicClip />,
  },
  {
    path: "/digital-agreement",
    element: <DigitalAgreement />
  },
  {
    path: "*",
    element: <Navigate to="/work-bench" />,
  }, //其他没有被注册过的路径统一重定位到login
];
export default routers;
